export default "__VITE_ASSET__iKE$dk8l__"